import React, { useState } from "react";
import { Button, DialogActions, DialogContent, DialogTitle, Pagination, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import ResponsiveDialog from "components/dialogs/ResponsiveDialog";
import SavedQueryRow from "components/queries/savedQueries/SavedQueryRow";
import { Query } from "system/query/Query";

interface SimpleQueryListProps {
  onClose(): void;
  queries: Array<Query>;
  title: string;
}

export default function SimpleQueryList(props: SimpleQueryListProps): React.JSX.Element {
  const { i18n } = useTranslation();

  const [page, setPage] = useState<number>(1);

  const pageSize = 5;
  const pageCount = Math.ceil(props.queries.length / pageSize);
  const queriesPage = props.queries.slice((page-1) * pageSize, page * pageSize);

  return (
    <ResponsiveDialog maxWidth="sm" open={true}>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent
        dividers
        sx={{ backgroundColor: "background.default", p: 1}}
      >
        <Stack sx={{ gap: 1 }}>
          {queriesPage.map((query) => {
            return (
              <SavedQueryRow
                key={query.id}
                savedQuery={query}
              />
            )
          })}
          {pageCount > 1 &&
            <Pagination
              count={pageCount}
              onChange={(event, page) => setPage(page)}
              page={page}
              sx={{ display: "flex", justifyContent: "center" }}
            />
          }
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          color="secondary"
          onClick={() => props.onClose()}
          variant="contained"
        >
          {i18n.t("close")}
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}